import { Product } from '@/micro/types/product.type'

/**
 * Verifica si en la url se encuentra el parametro
 *
 * Verifica en los parametros separados por /
 *
 * @param {*} name Nombre del parametro a buscar
 */
const getUrlParamBySlashSeparator = (name: string) => {
  const url = window.location.href

  const regex = new RegExp('[\/]' + name + '(\/([^&#\?]*))')
  let results = regex.exec(url)

  if (results && results[2]) {
    results[2] = results[2].split('/')[0]
  }

  return results
}

/**
 * Busca un query-param en la url y retorna el valor asociado.
 *
 * @param {String} name nombre del parámetro (tipo query) a buscar en la url.
 * @param {String} [location] (opcional) url a usar en vez de window.location.href
 * @returns Valor que tiene el parámetro.
 */
const getQueryParameterByName = (name: string, location?: string) => {
  const url = location || window.location.href

  name = name.replace(/[[\]]/g, '\\$&')

  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  let results = regex.exec(url)

  if (!results) {
    results = getUrlParamBySlashSeparator(name)
  }

  if (!results) return null
  if (!results[2]) return ''

  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

// const isVenezuelaUnlocked = (location?: string): boolean => {
//   const raw = getQueryParameterByName('venezuela', location)
//   return raw !== null && String(raw).toLowerCase() === 'true'
// }

/**
 * Obtiene el path basado en el producto
 *
 * @param {Product} product - El producto para determinar el path
 * @returns 'tpv' | 'punto-venta' | 'pos' | null
 */
const getPOSPath = (product: Product): 'tpv' | 'punto-venta' | 'pos' | null => {
  if (product === 'POS') return 'pos'
  if (product === 'TPV') return 'tpv'
  if (product === 'PUNTO-VENTA') return 'punto-venta'
  return null
}

/**
 * Obtiene el path basado en el producto
 *
 * @param {Product} product - El producto para determinar el path
 * @returns 'nomina' | null
 */
const getPayrollPath = (product: Product): 'nomina' | null => {
  if (product === 'AN') return 'nomina'
  return null
}

/**
 * Obtiene el path de la url actual para determinar si es tpv, punto-venta o pos
 *
 * @returns 'tpv' | 'punto-venta' | 'pos' | null
 */
const getPOSPathFromURL = (): 'tpv' | 'punto-venta' | 'pos' | null => {
  const urlArray = window.location.pathname.split('/')
  if (urlArray.includes('tpv')) return 'tpv'
  if (urlArray.includes('punto-venta')) return 'punto-venta'
  if (urlArray.includes('pos')) return 'pos'
  return null
}

/**
 * Obtiene el path de la url actual para determinar si es nomina
 *
 * @returns 'nomina' | null
 */
const getPayrollPathFromURL = (): 'nomina' | null => {
  const urlArray = window.location.pathname.split('/')
  if (urlArray.includes('nomina')) return 'nomina'
  return null
}

/**
 * Verifica si la url actual viene de POS
 *
 * @returns boolean
 */
const comesFromPOS = (): boolean => {
  const urlArray = window.location.pathname.split('/')
  return urlArray.includes('pos') || urlArray.includes('tpv') || urlArray.includes('punto-venta')
}

/**
 * Verifica si la url actual viene de nómina
 *
 * @returns boolean
 */
const comesFromPayroll = (): boolean => {
  const urlArray = window.location.pathname.split('/')
  return urlArray.includes('nomina')
}

/**
 * Verifica si la url es valida
 *
 * @param {*} url String a comprobar
 */
const isValidURL = (url: string) => {
  const urlPattern = /^https:\/\/([^\s.]+\.\S{2}|[^.]+\.[^.]{2,})(\.com)\S*$/
  return urlPattern.test(url)
}

export {
  getQueryParameterByName,
  getPOSPath,
  getPOSPathFromURL,
  getPayrollPath,
  getPayrollPathFromURL,
  comesFromPOS,
  comesFromPayroll,
  isValidURL,
  // isVenezuelaUnlocked,
}
